import { createSlice } from '@reduxjs/toolkit';

export const activitySlice = createSlice({
    name: 'activity',
    initialState: null,
    reducers: {
        activitySet: (state, action) => {
            return action.payload;
        }
    }
});

export const { activitySet } = activitySlice.actions;
export default activitySlice.reducer;
